import { compose } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import { getUrlParamsString } from 'helpers/shared';
import OpeningsDirectoryPicker from './index';

const form = 'openingsDirectoryPicker';

const mapStateToProps = (state, ownProps) => ({
  accountSlug: ownProps.accountSlug,
  brand: ownProps.brand,
  brands: ownProps.brands,
  brandsCountries: ownProps.brandsCountries,
  countries: ownProps.countries,
  embeddable: ownProps.embeddable,
  form: getFormValues(form)(state),
  urlParams: getUrlParamsString(),
});

export default compose(
  reduxForm({ form }),
  connect(mapStateToProps)
)(OpeningsDirectoryPicker);
